import { render } from "./PetsView.vue?vue&type=template&id=66c276c9"
import script from "./PetsView.vue?vue&type=script&lang=js"
export * from "./PetsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__